import { Button, Card, CardBody, Col, Container, FormControl, ListGroup, ListGroupItem, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { useQuery } from "react-query";
import LoadingMask from "../../components/form_masks/share/LoadingMask";
import ErrorMask from "../../components/form_masks/share/ErrorMask";
import { FaFilePdf } from "react-icons/fa";
import { useState } from "react";

const FormularePage = () => {

    const API = new PrivateApi();
    const [pdf, setPdf] = useState("");
    const [currentOpen, setCurrentOpen] = useState(0);
    const [qty, setQty] = useState("");
    const [formError, setFormError] = useState("");
    const [isDownloading, setIsDownloading] = useState(false);

    const {data, error, isLoading} = useQuery("GET_HV_FORMULARS", API.hw_formulars_active, {staleTime: Infinity});

    if (isLoading) return <LoadingMask />;
    if (error) return <ErrorMask error={error} />;


    const toggleCollapse = (id) => {
        if (id === currentOpen) setCurrentOpen(0);
        else setCurrentOpen(id);
    }

    const downloadFormular = (fid) => {
        const num = parseInt(qty);
        if (qty === "") {
            return setFormError("Darf nicht leer sein.")
        }
        if (Number.isNaN(num)) {
            return setFormError("Muss eine Zahl sein.");
        }
        setIsDownloading(true);

        API.hw_formular_download(fid, qty)
            .then(res => {
                const blob = new Blob([res.data], {type: "application/pdf"});
                let fileName = "download.pdf"
                const contentDisposition = res.headers['content-disposition'];

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const url = window.URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(url);

                setQty("");
                setCurrentOpen(0);

            })
            .catch(() => {
                setFormError("Download failed.");
            })
            .finally(() => setIsDownloading(false))
            ;
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h3>Formulare</h3>
                    <p className="text-muted">
                        Hier finden Sie die Anmeldeformulare für ENERGO Endkunden
                    </p>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col>
                    <Card className="shadow-lg">
                        <CardBody className="p-0">
                            <ListGroup>
                                {data && data.data.length > 0 &&
                                    data.data.map(formular => (
                                        <ListGroupItem key={`listitem-${formular.id}`} action as={"div"}>
                                            <div className="d-flex gap-2" onClick={() => toggleCollapse(formular.id)}>
                                                <FaFilePdf className="text-danger" size={30} />
                                                <span style={{userSelect: "none"}}>{formular.name}</span>
                                            </div>
                                            {currentOpen === formular.id &&
                                                <div className="mt-3 d-flex align-items-center gap-3">
                                                    <span>Anzahl:</span>
                                                    <div>
                                                        <FormControl
                                                            value={qty} 
                                                            onChange={e => {setQty(e.target.value); setFormError("")}} 
                                                            isValid={!Number.isNaN(Number(qty)) && qty !== ""}
                                                            isInvalid={formError !== ""}
                                                        />
                                                    </div>
                                                    <Button 
                                                        disabled={isDownloading}
                                                        onClick={() => downloadFormular(formular.id)} 
                                                        className="btn-energo"
                                                    >
                                                        {isDownloading ?
                                                            <Spinner animation="border" /> :
                                                            "Download"
                                                        }
                                                    </Button>
                                                    {formError !== "" &&
                                                            <small className="text-danger">{formError}</small>
                                                    }
                                                </div>
                                            }
                                        </ListGroupItem>
                                    ))
                                }
                            </ListGroup>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div>
                {pdf !== "" &&
                    pdf
                }
            </div>
        </Container>
    )
}
export default FormularePage;